module.exports = __webpack_public_path__ + "static/media/dictionary2.b25a6154.png";